/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {useAuth} from '../../../../app/modules/auth'
import {Languages} from './Languages'
import {toAbsoluteUrl} from '../../../helpers'
import {useAppDispatch, useAppSelector} from 'src/redux/storeHooks'
import {setLoggingData} from 'src/redux/slices/authSlice'
import {
  accessSessionTokenKeyName,
  refreshSessionTokenKeyName,
} from 'src/utils/constants'
import {useReturnToAdmin} from 'src/hooks/useReturnToAdmin'
import {useImpersonationSession} from 'src/hooks/useImpersonationSession'
import {COOKIE_CONSENT_KEY} from 'src/utils/cookieConsent'
import {
  captureInitialSyncCompletionStorage,
  restoreInitialSyncCompletionStorage,
} from 'src/utils/initialSyncCompletionStorage'
import {resetImpersonationForFreshLogin} from 'src/utils/impersonationTokens'
import {clearStaleLogoutGate} from 'src/utils/sessionExpiredLogout'
import {USER_DATA} from 'src/app/_interfaces/auth.interface'
import {MenuComponent} from 'src/marketConnect/assets/ts/components'

const HeaderUserMenu: FC = () => {
  const {currentUser, logout} = useAuth()
  const [userData, setUserData] = useState<USER_DATA>()
  const dispatch = useAppDispatch()
  const {fetchedUserAccountData,fetchedUserStaffData} = useAppSelector((state) => state.userAccountData)
  const { mainStoreData } = useAppSelector((state) => state.fetchConnectedPlatform)
  const adminRoles = ['SUPERADMIN', 'Read access', 'All Access'];
  const isAdminAccess = adminRoles.includes( fetchedUserAccountData?.user_type as string );
  const isStaffAccount = fetchedUserAccountData?.parent_user_role && fetchedUserStaffData?.account_type === "USER_STAFF";
  const {canReturnToAdmin} = useImpersonationSession()
  const {returnToAdmin} = useReturnToAdmin()

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  // useEffect(() => {
  //   // Dispatch the fetch user data action on component mount
  //   dispatch(fetchUserAccountDetailsAsync())
  //     .then((response) => {
  //       console.log('User account data:', response.payload)
  //       setUserData(response.payload) // Log the response data
  //     })
  //     .catch((error) => {
  //       console.error('Error fetching user data:', error)
  //     })
  // }, [localStorage.getItem(accessSessionTokenKeyName)])


  return (
    <div
      className='menu menu-sub  menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6'
      style={{minWidth: '275px', maxWidth: '340px', width: 'max-content'}}
      data-kt-menu='true'
    >
      <div className='menu-item px-2'>
        <div className='menu-content d-flex align-items-start py-1'>
          <div className='symbol symbol-40px'>
            <img alt='Logo' src={toAbsoluteUrl('/media/avatars/man_5-1024.webp')} />
          </div>
          <div
            className='d-flex flex-column flex-grow-1'
            style={{minWidth: 0, padding: '0.25rem 0 0.25rem 0.5rem'}}
          >
            <div
              className='fw-bolder d-flex align-items-center fs-5'
              title={fetchedUserAccountData?.name || ''}
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {fetchedUserAccountData?.name!}
            </div>
            <div
              className=' align-items-start grey'
              title={fetchedUserAccountData?.email || ''}
              style={{
                color: 'grey',
                maxWidth: '220px',
                whiteSpace: 'normal',
                overflowWrap: 'anywhere',
                wordBreak: 'break-word',
                lineHeight: 1.35,
              }}
            >
              {fetchedUserAccountData?.email!}
            </div>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      {/* 
      <div className='menu-item px-5'>
        <Link to={'/crafted/pages/profile'} className='menu-link px-5'>
          My Profile
        </Link>
      </div>

      <div className='menu-item px-5'>
        <a href='#' className='menu-link px-5'>
          <span className='menu-text'>My Projects</span>
          <span className='menu-badge'>
            <span className='badge badge-light-danger badge-circle fw-bolder fs-7'>3</span>
          </span>
        </a>
      </div>

      <div
        className='menu-item px-5'
        data-kt-menu-trigger='hover'
        data-kt-menu-placement='left-start'
        data-kt-menu-flip='bottom'
      >
        <a href='#' className='menu-link px-5'>
          <span className='menu-title'>My Subscription</span>
          <span className='menu-arrow'></span>
        </a>

        <div className='menu-sub menu-sub-dropdown w-175px py-4'>
          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Referrals
            </a>
          </div>

          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Billing
            </a>
          </div>

          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Payments
            </a>
          </div>

          <div className='menu-item px-3'>
            <a href='#' className='menu-link d-flex flex-stack px-5'>
              Statements
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='View your statements'
              ></i>
            </a>
          </div>

          <div className='separator my-2'></div>

          <div className='menu-item px-3'>
            <div className='menu-content px-3'>
              <label className='form-check form-switch form-check-custom form-check-solid'>
                <input
                  className='form-check-input w-30px h-20px'
                  type='checkbox'
                  value='1'
                  defaultChecked={true}
                  name='notifications'
                />
                <span className='form-check-label text-muted fs-7'>Notifications</span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div className='menu-item px-5'>
        <a href='#' className='menu-link px-5'>
          My Statements
        </a>
      </div>

      <div className='separator my-2'></div>

      <Languages />
       */}

      {/* Account Settings link moved to Navbar top gear icon */}

      {/* {( fetchedUserStaffData?.account_type === "ADMIN_STAFF" || localStorage.getItem(loggedInAdminAccessToken)) ? (
        <div className='menu-item px-4 my-1 '>
          <Link to='/application-logs' className='menu-link ' style={{textDecoration: 'none'}}>
            New Application Logs
          </Link>
        </div>
      ) : null} */}

     {!fetchedUserAccountData?.isStaffUser &&  fetchedUserAccountData?.account_type !== 'SUPERADMIN' &&
            fetchedUserAccountData?.account_type !== 'USER_STAFF' && fetchedUserAccountData?.parent_user_role?.billing_access !== "RESTRICT" && (
        <div className='menu-item px-4 my-1 position-relative d-inline'>
          <Link
            to={mainStoreData?.id ? `/pricing/${mainStoreData?.id}` : '/pricing'}
            className='menu-link'
            style={{textDecoration: 'none'}}
          >
            Billing
          </Link>
        </div>
      )}

        {/* {isAdminAccess || (isLoginAdminAcess) ? (
        <div className='menu-item px-4 my-1 '>
          <Link to='/history/logs' className='menu-link ' style={{textDecoration: 'none'}}>
            History Logs
          </Link>
        </div>
      ) : null} */}

      {/* { (fetchedUserAccountData?.user_type!=='SUPERADMIN' && fetchedUserAccountData?.isOnboardingProcessCompleted) && (!fetchedUserAccountData?.isStaffUser && ['SHOPIFY', 'WOOCOMMERCE','ECWID','COMMERCIUM','WIX' ].includes(fetchedUserAccountData?.source!))  ?
        <div className='menu-item px-4 my-1 '>
          <Link
            to='/billing-detail'
            className='menu-link'
            style={{textDecoration: 'none'}}
          >
            Subscription Details
          </Link>
        </div> 
      : null } */}

      <div className='menu-item px-4'>
        <a
          onClick={() => {
            const cookieConsent = localStorage.getItem(COOKIE_CONSENT_KEY)
            const initialSyncCompletions = captureInitialSyncCompletionStorage()
            resetImpersonationForFreshLogin()
            clearStaleLogoutGate()
            localStorage.removeItem(accessSessionTokenKeyName)
            localStorage.removeItem(refreshSessionTokenKeyName)
            localStorage.clear()
            if (cookieConsent) localStorage.setItem(COOKIE_CONSENT_KEY, cookieConsent)
            restoreInitialSyncCompletionStorage(initialSyncCompletions)
            dispatch(setLoggingData({isLoggedIn: false, userData: null}))
            document.location.reload()
          }}
          className='menu-link '
          style={{textDecoration: 'none'}}
        >
          Sign Out
        </a>
      </div>
      {canReturnToAdmin && (
        <div className='menu-item px-4'>
          <a
            onClick={() => returnToAdmin()}
            className='menu-link text-primary'
            style={{textDecoration: 'none'}}
          >
            {!isStaffAccount ? 'Back to Admin' : 'Back to Organization List'}
          </a>
        </div>
      )}
    </div>
  )
}

export {HeaderUserMenu}
